import React from 'react'
import { DocumentSection } from '../../../entities/Document'
import styled from '@emotion/styled'
import { TableRow } from './TableRow'

const ResponsiveTable = styled.table`
  width: 100%;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;

  @media (max-width: 1024px) {
    display: none;
  }
`

const StyledThead = styled.thead``

const StyledTbody = styled.tbody``

const HeaderRow = styled.tr``

const HeaderCellFirst = styled.th`
  background-color: #f3f4f6;
  padding: 8px 10px;
  width: 60px;
  border-top-left-radius: 12px;
  border-bottom: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
  height: 40px;
  vertical-align: middle;
`

const HeaderCellSecond = styled.th`
  padding: 8px 10px;
  border-bottom: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
  width: 30%;
  height: 40px;
  vertical-align: middle;
`

const HeaderCellThird = styled.th`
  padding: 8px 10px;
  border-bottom: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
  height: 40px;
  vertical-align: middle;
`

const HeaderCellLast = styled.th`
  padding: 8px 10px;
  border-bottom: 1px solid #e5e7eb;
  border-top-right-radius: 12px;
  height: 40px;
  vertical-align: middle;
`

interface FreshTableViewProps {
  sections: DocumentSection[]
  onDocumentationClick: (section: DocumentSection) => void
}

export const FreshTableView: React.FC<FreshTableViewProps> = ({
  sections,
  onDocumentationClick
}) => {
  return (
    <ResponsiveTable>
      <StyledThead>
        <HeaderRow>
          <HeaderCellFirst>№</HeaderCellFirst>
          <HeaderCellSecond>Раздел документации</HeaderCellSecond>
          <HeaderCellThird>Проектная документация</HeaderCellThird>
          <HeaderCellLast>Рабочая документация</HeaderCellLast>
        </HeaderRow>
      </StyledThead>
      <StyledTbody>
        {sections.map(section => (
          <TableRow
            key={section.id}
            section={section}
            onDocumentationClick={onDocumentationClick}
          />
        ))}
      </StyledTbody>
    </ResponsiveTable>
  )
}
